import React, { ReactNode } from 'react';
import { actionBarMinWidthWrapper } from 'src/components/common/common';

interface SearchSectionFormProps {
  children: ReactNode;
}
// 공통으로 사용하지 못할 부분이라 따로 분리하여 수정 
export const SearchSectionForm: React.FC<SearchSectionFormProps> = ({ children }) => {
  return (
    <div className={`w-full h-[40px] flex items-center justify-between gap-[6px] `}>
		<div className={`w-full h-full flex items-center gap-[8px] border-gray-300 px-[6px] border overflow-x-auto ${actionBarMinWidthWrapper}`}>
			{children}
		</div>
    </div>
  );
};